<div class="me-dashboard">
    <div class="me-dashboard--process">
        <div class="me-dashboard--process__step step"
            style="--step: '{{meService.PATIENTSTEPS.SR}}'"
             [ngClass]="{
             'checked' : patientStep > meService.PATIENTSTEPS.SR,
             'active' : patientStep === meService.PATIENTSTEPS.NOTSTART || patientStep === meService.PATIENTSTEPS.SR,
             'hide-text' : this.appService.isMobile && patientStep !== meService.PATIENTSTEPS.SR && patientStep !== meService.PATIENTSTEPS.NOTSTART
                }"
        >
            {{ this.appService.isMobile && patientStep !== meService.PATIENTSTEPS.SR && patientStep !== meService.PATIENTSTEPS.NOTSTART ? '' : content?.step1 }}
        </div>
        <div class="me-dashboard--process__step"
            style="--step: '{{meService.PATIENTSTEPS.EVALUATION_INTERVIEW}}'"
             [ngClass]="{
             'checked' : patientStep > meService.PATIENTSTEPS.EVALUATION_INTERVIEW,
             'active' : patientStep === meService.PATIENTSTEPS.EVALUATION_INTERVIEW,
             'hide-text' : this.appService.isMobile && patientStep !== meService.PATIENTSTEPS.EVALUATION_INTERVIEW
                }"
             >
            {{ this.appService.isMobile && patientStep !== meService.PATIENTSTEPS.EVALUATION_INTERVIEW ? '' : content?.step2 }}
        </div>
        <div class="me-dashboard--process__step"
            style="--step: '{{meService.PATIENTSTEPS.EXPORT_RECOMMENTDATION}}'"
             [ngClass]="{
             'checked' : patientStep > meService.PATIENTSTEPS.EXPORT_RECOMMENTDATION,
             'active' : patientStep === meService.PATIENTSTEPS.EXPORT_RECOMMENTDATION,
             'hide-text' : this.appService.isMobile && patientStep !== meService.PATIENTSTEPS.EXPORT_RECOMMENTDATION
                }"
             >
            {{ this.appService.isMobile && patientStep !== meService.PATIENTSTEPS.EXPORT_RECOMMENTDATION ? '' : content?.step3 }}
        </div>
    </div>

    <main>
        <div class="container pb-2">
            <div class="me-dashboard--tasklists">
                <div class="row tasklists sticky">
                    <!--    TASK LISTS  -->
                    <div class="tasklists--dashboard mr-t--md">
                        <ul class="nav nav-justified nav-tabs">
                            <li tabindex="0" role="tab" class="nav-item" (click)="selectTab(0)" (keyup.enter)="selectTab(0);">
                                <a class="nav-link" [class.active]="tabSelected == 0">
                                    <span class="flex-center">
                                        {{ 'My Dashboard' | translate }}
                                    </span>
                                </a>
                            </li>
                            <li tabindex="0" role="tab" class="nav-item" (click)="selectTab(1);" (keyup.enter)="selectTab(1);">
                                <a class="nav-link" [class.active]="tabSelected == 1">
                                    <span class="flex-center">
                                        {{ 'My results' | translate }}
                                        <span class="tab-notification" *ngIf="documentCount">{{documentCount}}</span>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="row tasklists tasklists--wrapper__content">
                    <tabset #tabs [justified]="true" class="tasklists">
                        <tab (select)="selectTab(0)" class="tasklists--tab">
                            <div class="row tasklists--tab--wrapper" *ngIf="data">
                                <ng-container *ngIf="patientStep === 0 || (patientStep === 3 && canCreateNewSR)">
                                    <div class="me-dashboard-card">
                                        <me-sr-dashboard-card [srStep]="srStep" [questionnaireToken]="questionnaireToken">
                                        </me-sr-dashboard-card>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="patientStep === meService.PATIENTSTEPS.SR">
                                    <ng-container *ngIf="isSRPaid === 0">
                                        <div class="me-dashboard-card" *ngIf="packages[mePackageService.TYPE.MAP]['id']">
                                            <me-package [bexioData]="packages[mePackageService.TYPE.MAP]" [type]="mePackageService.TYPE.MAP"></me-package>
                                        </div>
                                        <div class="me-dashboard-card" *ngIf="packages[mePackageService.TYPE.COMBINED]['id']">
                                            <me-package [bexioData]="packages[mePackageService.TYPE.COMBINED]" [type]="mePackageService.TYPE.COMBINED"></me-package>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="isSRPaid === 1 && patientStep === meService.PATIENTSTEPS.EVALUATION_INTERVIEW">
                                    <div class="me-dashboard-card" *ngIf="isCVPaid === 0 && packages[mePackageService.TYPE.APPOINTMENT]['id']">
                                        <me-package
                                                [bexioData]="packages[mePackageService.TYPE.APPOINTMENT]"
                                                [type]="mePackageService.TYPE.APPOINTMENT">
                                        </me-package>
                                    </div>
                                    <div class="me-dashboard-card" *ngIf="packages[mePackageService.TYPE.APPOINTMENTWITHDISCOUNT]['id'] && isAppointmentDiscount === 0">
                                        <me-package [bexioData]="packages[mePackageService.TYPE.APPOINTMENTWITHDISCOUNT]"
                                                    [type]="mePackageService.TYPE.APPOINTMENTWITHDISCOUNT">
                                        </me-package>
                                    </div>
                                    <div class="me-dashboard-card" *ngIf="isCVPaid === 1 && !meetingUrl && (isAppointmentDiscount === 1 || isAppointmentDiscount === null)">
                                        <me-appointment-booking-card></me-appointment-booking-card>
                                    </div>
                                    <div class="me-dashboard-card" *ngIf="isCVPaid === 1 && meetingUrl">
                                        <me-appointment-booked-card  [meetingTime]="meetingTime" [meetingUrl]="meetingUrl"></me-appointment-booked-card>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="meService.notifications.length > 0 && myResultCards">
                                    <me-banners
                                            *ngFor="let card of myDashboardCards; let i = index"
                                            class="me-banners col-xs-6 col-order-{{i}}"
                                            [patientStep]="patientStep"
                                            [srStep]="srStep"
                                            [card]="card"
                                    ></me-banners>
                                </ng-container>
                            </div>
                        </tab>

                        <tab (select)="selectTab(1)" class="tasklists--tab">
                            <div class="row me-dashboard" *ngIf="data">
                                <div class="me-dashboard--box" *ngIf="myResultCards.length">
                                    <ng-container *ngFor="let card of myResultCards">
                                        <me-dynamic-overview-card
                                                *ngIf="isSRPaid === 1 && card['slug'] == CARDS.overview.slug"
                                                class="me-dashboard--box--card">
                                        </me-dynamic-overview-card>

                                        <me-diagnosis-prediction-card
                                                *ngIf="isSRPaid === 1 && meDashboardService.showPredictionCard && card['slug']== CARDS.diagnosis.slug"
                                                class="me-dashboard--box--card"
                                        ></me-diagnosis-prediction-card>

                                        <documents-card
                                                *ngIf="card['slug'] == CARDS.documents.slug"
                                                class="me-dashboard--box--card"
                                                [patientStep]="patientStep"
                                                [srStep]="srStep"
                                                [slug]="'documents'"
                                        ></documents-card>

                                        <diga-card
                                                *ngIf="card['slug'] == CARDS.diga.slug"
                                                class="me-dashboard--box--card"
                                                [patientStep]="patientStep"
                                                [srStep]="srStep"
                                                [slug]="'diga-card'"
                                        ></diga-card>

                                        <article-card
                                                *ngIf="card['slug'] == CARDS.barmer.slug"
                                                class="me-dashboard--box--card"
                                                [patientStep]="patientStep"
                                                [srStep]="srStep"
                                                [slug]="'article-card'"
                                        ></article-card>
                                    </ng-container>
                                </div>
                            </div>
                        </tab>
                    </tabset>
                </div>
            </div>
        </div>
        <me-nps [slug]="'net-promoter-score'" [callApi]="true" #npsComponent></me-nps>
    </main>
</div>